import { ReadTimeShape } from './style';

export default ReadTimeShape;
